import {Product} from "../../model/types";
import {isOutOfStock} from "../../model/availability";
import {getPriceMeta} from "../../model/getPriceMeta";
import {formatPrice} from "@/shared/lib/format/formatPrice";
import styles from "./ProductPrice.module.scss";

type Props = {
    product: Product;
};

export const ProductPrice = ({product}: Props) => {
    const {
        current,
        original,
        hasDiscount,
        discount,
        discountColor,
        discountBg,
    } = getPriceMeta(product);

    const discountStyle =
        discountColor || discountBg
            ? {
                ...(discountColor && {color: discountColor}),
                ...(discountBg && {backgroundColor: discountBg}),
            }
            : undefined;

    if (isOutOfStock(product)) {
        return (
            <p className={styles.outOfStockText}>
                Нет в наличии
            </p>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.current}>{formatPrice(current)}</div>
            {hasDiscount && (
                <div className={styles.oldContainer}>
                    <div className={styles.old}>{formatPrice(original)}</div>
                    {!!discount && (
                        <div className={styles.discount} style={discountStyle}>
                            -{discount}%
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
